import React from "react";

export default function Education() {
  return (
    <div
      id="education"
      className="bg-mesanfaz-gray-2 px-6 sm:px-8 md:px-12 py-8 md:py-12 items-center"
    >
      <div className="font-black text-4xl sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl">
        education
      </div>
      <div className="pt-12">
        <ol className="relative border-l border-mesanfaz-black">
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-black rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl font-black">
              Informatics
            </h3>
            <time className="block mb-2 leading-none">
              Cyber Asia University
            </time>
            <time className="block mb-4 leading-none">Oct 2022 - Present</time>
          </li>
          <li className="ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-black rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl font-black">
              Software Engineering
            </h3>
            <time className="block mb-2 leading-none">SMK Negeri 3 Metro</time>
            <time className="block mb-4 leading-none">Jul 2018 - Jul 2021</time>
          </li>
        </ol>
      </div>
    </div>
  );
}
